<template>
    <div class="pie">

        <div class="headline" v-if="headline">
            {{ headline }}
        </div>

        <vue-apex-charts
            :options="chartOptions"
            :series="series"
            :labels="labels"
            :height="chartOptions.chart.height"
        />

    </div>
</template>

<style lang="scss" scoped>
@import "../../../../styles/vars.scss";

    .headline {
        font-size: $fontsize--main;
        font-weight: 600;
        margin-bottom: $margin--small;
        text-align: center;
        font-family: $fontfamily--secondary;
    }

</style>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
    props: ['headline', 'series', 'labels', 'division'],
    data () {
        return {
            chartOptions: {
                series: [],
                labels: this.labels ? this.labels : null,
                colors: this.division === true ? ['#4CAF50', '#FF5252'] : this.$store.state.graphColors,
                chart: {
                    type: 'pie',
                    height: '300px'
                },
                tooltip: {
                    enabled: true,
                    y: {
                        formatter: (value) => {
                            let percent = Math.round((value / this.total) * 100)
                            return this.$options.filters.rounded(value) + ' timer (' + percent + '%)'
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: (val) => {
                        return this.$options.filters.rounded(val) + ' %'
                    }
                },
                legend: {
                    show: false,
                    position: 'bottom',
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    }
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                value: {
                                    formatter: (value) => {
                                        let percent = Math.round((value / this.total) * 100)
                                        return this.$options.filters.rounded(value) + ' timer (' + percent + '%)'
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    components: {
        VueApexCharts
    },
    computed: {
        total () {
            let count = 0
            this.series.forEach((item) => {
                count += item
            })
            return count
        }
    }
}
</script>



// WEBPACK FOOTER //
// pie.vue?5a0fc1bb